import React, { Component } from "react";
import styles from "./trips.module.scss";
import { withLogisticTrips } from "../../../shared/containers/containerLogisticTrips";
import TripsList from "./TripsList";
import FilterAndSearchTripTools from "../FilterTools/FilterAndSearchTripTools";
import CreateTrip from "./CreateTrip";
import { withAuth } from "../../../shared/containers/containerAuth";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import ControlPointIcon from "@mui/icons-material/ControlPoint";

const viewPanelItems = {
  tripsList: "tripsList",
  createTrip: "createTrip",
};

class Trips extends Component {
  constructor(props) {
    super(props);

    this.state = {
      viewPanel: viewPanelItems.tripsList,
    };
  }

  onSetViewPanel(viewPanel) {
    this.setState({ viewPanel });
  }

  componentDidMount() {
    const tripId = window.location.pathname.replace("/logistic/trips", "");

    if (tripId !== "" && tripId !== "/") {
      this.setState({ viewPanel: viewPanelItems.createTrip });
    }
  }

  onClickCreate() {
    const { onCreateLogisticTrip } = this.props;

    onCreateLogisticTrip({
      id: null,
      title: "Рейс без наименования",
      description: null,
      trips: [],
      timeZone: (new Date().getTimezoneOffset() / 60) * -1,
    });

    this.setState({ viewPanel: viewPanelItems.createTrip });
  }

  render() {
    const { onGetLogisticTrips, data } = this.props;
    const { viewPanel } = this.state;
    const setViewPanel = this.onSetViewPanel.bind(this);

    const tripCreatePermission = data.permissions.includes(29001);

    return (
      <div className={styles.tripsMainContainer}>
        {viewPanel === viewPanelItems.tripsList ? (
          <div>
            <div className={styles.tripsToolsPanel}>
              <FilterAndSearchTripTools onFilter={onGetLogisticTrips} />

              {tripCreatePermission ? (
                <TooltipWrapper title={"Создать новый рейс"} position="left">
                  <ControlPointIcon
                    className={styles.icon}
                    fontSize="large"
                    onClick={() => {
                      this.onClickCreate();
                    }}
                  />
                </TooltipWrapper>
              ) : (
                <div></div>
              )}
            </div>

            <TripsList viewPanelItems={viewPanelItems} onSetViewPanel={setViewPanel} />
          </div>
        ) : null}

        {viewPanel === viewPanelItems.createTrip ? <CreateTrip viewPanelItems={viewPanelItems} onSetViewPanel={setViewPanel} /> : null}
      </div>
    );
  }
}

export default withAuth(withLogisticTrips(React.memo(Trips)));
